import { Component, Input } from '@angular/core'

@Component({
	selector: 'app-pagination',
	templateUrl: './pagination.component.html'
})
export class PaginationComponent {
		@Input() public totalPages: number = 0
		@Input() public thisPage: number = 0
}
